import "core-js/modules/es6.regexp.split";
import has from 'lodash/has';
import each from 'lodash/each';
import isArray from 'lodash/isArray';
import isString from 'lodash/isString';
/**
 *  `pickWildcards(object, path)`
 *  is a method that will return all items matching a `wildcard` path
 *    - e.g. 'foo.*.bar' would find all values for all keys names 'bar'
              in objects in list under key `foo`
 *  Using this method is very similar to lodash `pick(object, path)`,
 *  with one very notable difference:
 *  - returns object with all matched values, keyed by full path in object
 *    - these keys are string paths compatible with lodash `set` and `get`
 * */

export default function pickWildcards(obj, paths) {
  var output = {};

  if (isString(paths)) {
    return mapWildcardValues(obj, paths, output); // eslint-disable-line no-use-before-define
  }

  if (isArray(paths)) {
    each(paths, function (path) {
      return mapWildcardValues(obj, path, output);
    }); // eslint-disable-line no-use-before-define

    return output;
  }

  throw new Error('pickWildcards: second argument `paths` must be a string or array of strings');
}
export function mapWildcardValues(obj, path) {
  var output = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  if (isString(path)) return mapWildcardValues(obj, path.split('.'), output);
  recursivelyMapWildcardValues(obj, path, output); // eslint-disable-line no-use-before-define

  return output;
}

function recursivelyMapWildcardValues(obj, path, output, keyPath) {
  var currentPath = path[0]; // check if recursion has made it to the bottom

  if (currentPath === undefined) {
    // set the full path key in output to this obj value
    output[keyPath] = obj; // eslint-disable-line no-param-reassign

    return;
  } // prepare prefix for next keyPath


  var keyPathPrefix = keyPath !== undefined && keyPath.length > 0 ? "".concat(keyPath, ".") : ''; // check for wildcard

  if (currentPath === '*') {
    // loop over and recurse into all items in the list
    var pathAfterWildcard = path.slice(1);
    return each(obj, function (item, i) {
      return recursivelyMapWildcardValues(item, pathAfterWildcard, output, "".concat(keyPathPrefix).concat(i));
    });
  } // get the next object in the path and recurse


  if (has(obj, currentPath)) {
    return recursivelyMapWildcardValues(obj[currentPath], path.slice(1), output, "".concat(keyPathPrefix).concat(currentPath));
  } // nothing more to set

}